import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import classNames from "classnames"
import SegueLink from "app/static/frontend/middleware/SegueLink"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

// Render a button for Sheets
/** @type {(props: any) => React.ReactElement} */
const SheetsButton = ({
    block,
    className,
    disabled,
    icon,
    segueUrl,
    onClick,
    style,
    variant,
    dataPlumId,
    ...props
}) => (
    <SegueLink to={disabled ? undefined : segueUrl}>
        <Tooltip label={disabled ? props.disabledTooltipLabel : props.tooltipLabel}>
            <Button
                className={classNames(className, block && "btn-block")}
                disabled={disabled}
                id="sheet-settings-button"
                onClick={onClick}
                size="md"
                style={style}
                variant={variant}
                data-plum-id={dataPlumId}
            >
                {icon} {disabled ? props.disabledText : props.buttonText}
            </Button>
        </Tooltip>
    </SegueLink>
)

SheetsButton.propTypes = {
    buttonText: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    disabledText: PropTypes.string,
    disabledTooltipLabel: PropTypes.string,
    icon: PropTypes.instanceOf(Icon),
    onClick: PropTypes.func,
    segueUrl: PropTypes.string,
    tooltipLabel: PropTypes.string,
    variant: PropTypes.string,
    dataPlumId: PropTypes.string,
}

SheetsButton.defaultProps = {
    buttonText: "New Column",
    className: "sheets-buttons",
    disabled: false,
    disabledText: "Sheet Disabled",
    disabledTooltipLabel: "This sheet is disabled. Only the owner has full permissions.",
    icon: <Icon name="plus" />,
    segueUrl: "",
    tooltipLabel: "Add a new Column.",
    variant: "default",
}

export default SheetsButton
